// extracted by mini-css-extract-plugin
export default {"customization":"Customization_customization__kofrX","wrapperOuter":"Customization_wrapperOuter__m8PMM","wrapperInner":"Customization_wrapperInner__9xNQV"};